import React from "react";
import { Link } from "react-router-dom";
import "./navbar.css";
import "../../global.css";
import { IoReorderThreeOutline } from "react-icons/io5";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";
import { useTranslate } from "../../utils/useTranslate";
import { setLanguage } from "../../redux/languageSlice";
import { setIsOpenContentsModal } from "../../redux/contentSlice";

const Navbar = () => {
  const translate = useTranslate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { language } = useSelector((state) => state.language);

  const { isOpenContentsModal } = useSelector((state) => state.content);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className="navbarContainer">
      <div className="subNavbarContainerLeft">
        <Link to="/home" style={{ textDecoration: "none" }}>
          {isMobile === false ? (
            <span className="headStyle textFlex">
              {translate("arkyMultimediaAnalyticsLab")}
            </span>
          ) : (
            <span className="linkTextStyle textFlex">
              {translate("arky")}
            </span>
          )}
        </Link>
      </div>
      <div className="subNavbarContainerRight">
        <Link to="/about" style={{ textDecoration: "none" }}>
          <span
            className="linkTextStyle textMono"
            style={{
              color: location.pathname === "/about" ? "#EF4536" : "#100F0D",
            }}
          >
            {language.value === "tr"
              ? translate("about").toLocaleUpperCase("tr-TR")
              : translate("about").toLocaleUpperCase("en-US")}
          </span>
        </Link>
        <Link to="/crew" style={{ textDecoration: "none" }}>
          <span
            className="linkTextStyle textMono"
            style={{
              color: location.pathname === "/crew" ? "#EF4536" : "#100F0D",
            }}
          >
            {language.value === "tr"
              ? translate("crew").toLocaleUpperCase("tr-TR")
              : translate("crew").toLocaleUpperCase("en-US")}
          </span>
        </Link>
        <span
          className="linkTextStyle textMono"
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            marginRight: "33px",
          }}
          onClick={() =>
            dispatch(
              setLanguage(
                language.value === "tr"
                  ? { title: "English", value: "en" }
                  : { title: "Türkçe", value: "tr" }
              )
            )
          }
        >
          {language.value === "tr" ? "ENGLISH" : "TÜRKÇE"}
        </span>
        {!isMobile && (
          <Link
            className="allContentStyle"
            style={{ textDecoration: "none" }}
            onClick={() =>
              dispatch(setIsOpenContentsModal(!isOpenContentsModal))
            }
          >
            <IoReorderThreeOutline
              style={{ fontSize: "18px", color: "#100F0D" }}
            />
            <span className="linkTextStyle textMono">
              {language.value === "tr"
                ? translate("allContent").toLocaleUpperCase("tr-TR")
                : translate("allContent").toLocaleUpperCase("en-US")}
            </span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Navbar;
